/**
 * Market availability flags.
 *
 * The US storefront (`/us`) is built but not actively operated: it is hidden
 * from navigation and market/language selectors, and excluded from the
 * sitemap + search indexing. Flip this to `true` once US fulfilment,
 * pricing and English product content are verified for every SKU.
 */
export const US_MARKET_ENABLED = false;

/**
 * Public language options.
 *
 * Swedish (and the other non-Finnish dictionaries) currently translate the UI
 * chrome only — product titles, descriptions, specs, FAQ and legal pages are
 * still Finnish, so a shopper who picks "Svenska" gets a half-translated
 * purchase flow. The translation infrastructure stays in place; the option is
 * simply hidden until a locale's whole purchasing experience is localized.
 *
 * Flip a locale to `true` once its content is complete.
 */
export const PUBLIC_LOCALES: Record<"fi" | "en" | "sv" | "et", boolean> = {
  fi: true,
  en: true,
  sv: false,
  et: true,
};
